import { Box, Grid2, styled } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { colors, theme } from '@watter/shared-components';

import SplashLogo from '../../assets/images/splash-image.png';
import { focuseEffect } from '../common-styles';

const dividerMixin = (deg: number, leftValue: any, rightValue: any) => ({
    content: "''",
    height: '1px',
    width: '25%',
    top: '12px',
    border: '1px solid transparent',
    position: 'absolute',
    borderImage:
        theme.palette.mode === 'dark'
            ? `linear-gradient(-${deg}deg, ${colors.blackColor} 0%, ${colors.white} 100%) 1`
            : `linear-gradient(${deg}deg, ${colors.blackColor} 0%,  ${colors.white} 100%) 1`,
    left: leftValue,
    right: rightValue,
});

export const useStyles = makeStyles({
    signInpopup: {
        '& .MuiPaper-root': {
            backgroundColor: 'rgba(32, 18, 2, 0.67)',
            margin: 0,
            padding: '24px',
            fontSize: theme.spacing(2),
            '& .MuiTypography-h6': {
                padding: 0,
                marginBottom: '16px',
                '& .MuiButtonBase-root': {
                    fontSize: '15px',
                    color: '#6B7280',
                },
            },
            '& .MuiDialogContent-root': {
                padding: 0,
                '& .link': {
                    '& a': {
                        padding: '0px 3px',
                        textDecoration: 'none',
                    },
                },
            },
        },
    },
});

const isDark = (theme: any) => theme.palette.mode === 'dark';

const backgroundFill = (theme: any) => (isDark(theme) ? colors.darkBgButton : colors.white);

const boxShadowColor = (theme: any) =>
    isDark(theme)
        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040';

const fieldSetColor = (theme: any) => (isDark(theme) ? colors.lightHead : colors.lightGray);
const subTitleColor = (theme: any) => (isDark(theme) ? colors.info : colors.gray);
const inputColor = (theme: any) => (isDark(theme) ? colors.white : colors.blackColor);
export const ProfileMainWrapper = styled(Box)(({ theme }) => ({
    background: backgroundFill(theme),
    boxShadow: '0px 0px 30px 0px #0000001A',
    padding: theme.spacing(5),
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(1),
    display: 'flex',
    alignItems: 'flex-start',
    columnGap: theme.spacing(3),
    height: 'calc(100dvh - 215px)',
    overflow: 'auto',
    rowGap: theme.spacing(2.5),
    '& form': {
        display: 'grid',
        gridTemplateColumns: '1fr 35%',
        gap: theme.spacing(3),
        zIndex: 0,
        [theme.breakpoints.down('md')]: {
            display: 'flex',
            alignItems: 'flex-start',
            flexDirection: 'column-reverse',
            gap: theme.spacing(1),
        },
    },
    '& .details': {
        '& .MuiTypography-subtitle1': {
            fontFamily: 'good_sansregular',
            color: subTitleColor(theme),
        },
        '& input,.MuiSelect-select ': {
            padding: theme.spacing(1.0625, 0),
            textOverflow: 'ellipsis',
        },
        '& .MuiInputBase-root.MuiOutlinedInput-root, .MuiInputBase-root.MuiOutlinedInput-root.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0 0 1px 0',
                borderRadius: 0,
                borderColor: colors.lightGray,
            },
        },
        '& .MuiInputBase-root.Mui-disabled': {
            '& .MuiInputBase-input': {
                color: inputColor(theme),
                '-webkit-text-fill-color': 'inherit',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
        '& .header': {
            fontFamily: 'good_sansbold',
        },
        '&.profileDetails': {
            '& .MuiFormControl-root': {
                marginBottom: theme.spacing(0),
            },
            '& .MuiGrid2-root': {
                '& .MuiStack-root': {
                    position: 'relative',
                    '& .MuiFormHelperText-root': {
                        position: 'absolute',
                        bottom: theme.spacing(-2.5),
                    },
                },
            },
        },
        '& .cstVerify': {
            position: 'relative',
            '& .MuiButton-root': {
                position: 'absolute',
                right: theme.spacing(0),
                top: theme.spacing(3.5),
                fontSize: theme.spacing(1.5),
                letterSpacing: 0,
                '&.verify': {
                    background: colors.errorRedBg,
                    color: colors.errorTextBtn,
                },
                '&.verified': {
                    background: colors.verifyBg,
                    color: colors.verifyText,
                },
            },
            '&.cstMobileNumber': {
                '& .MuiSelect-select': {
                    textOverflow: 'inherit',
                },
            },
        },
        '& .cstEmail': {
            '& .cstDisableEmail': {
                '& .MuiInputBase-root.Mui-disabled': {
                    '& .MuiInputBase-input': {
                        color: 'gray',
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        borderBottom: `1px solid ${colors.lightGray}`,
                    },
                },
            },
        },
    },

    '& .actionFooter': {
        '& .cstBtn': {
            boxShadow: boxShadowColor(theme),
            background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
            color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
            fontSize: theme.spacing(1.75),
            padding: theme.spacing(1.5, 2),
            fontFamily: 'good_sansmedium',
            minWidth: theme.spacing(17.5),
            whiteSpace: 'nowrap',
            position: 'relative',
            '&:focus::after': focuseEffect(),
        },

        [theme.breakpoints.down('sm')]: {
            rowGap: theme.spacing(2),
            '& .MuiBox-root': {
                width: '100%',
                '& .cstBtn': {
                    minWidth: '100%',
                },
            },
        },
    },
    '& .profile': {
        [theme.breakpoints.down('md')]: {
            textAlign: 'center',
            margin: 'auto',
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            '& img': {
                width: theme.spacing(20),
                height: theme.spacing(20),
                borderRadius: '50%',
                boxShadow: '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
            },
        },
    },
    '& .cstEditProfile': {
        '& .MuiSelect-select': {
            paddingLeft: 0,
        },
        '& .MuiSelect-nativeInput': {
            background: 'transparent',
            border: 0,
            fontFamily: 'good_sansregular',
            color: isDark(theme) ? colors.white : colors.blackColor,
        },
    },
    '& .cstSelectProfile': {
        '& .MuiInputLabel-root': {
            left: theme.spacing(-1.75),
            color: colors.placeholder,
            [theme.breakpoints.up('md')]: {
                top: theme.spacing(-2.375),
            },
        },
        '& .MuiOutlinedInput-notchedOutline': {
            borderBottom: `1px solid ${colors.lightGray} !important`,
        },
        '&.cstState': {
            '& .MuiInputLabel-root': {
                top: theme.spacing(0),
            },
            '& .MuiInputBase-root,input': {
                paddingLeft: theme.spacing(0),
            },
        },
    },
    '& .cstProfileImage': {
        padding: theme.spacing(0, 3.75),
        [theme.breakpoints.up('md')]: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
        },
        [theme.breakpoints.down('md')]: {
            margin: 'auto',
        },
        [theme.breakpoints.between(768, 1200)]: {
            padding: theme.spacing(0),
        },
        '& .cstProfileImageStack': {
            position: 'relative',
            '& .ReactCrop': {
                zIndex: 9,
            },
            '& img': {
                borderRadius: theme.spacing(2),
            },
            '& .cstProfileImageEdit': {
                position: 'absolute',
                inset: 0,
                display: 'none',
                alignItems: 'center',
                justifyContent: 'center',
                '& input': {
                    display: 'none',
                },
                '&:hover': {
                    backdropFilter: ' brightness(0.4)',
                },
                '& .MuiIconButton-root': {
                    color: colors.white,
                },
            },
            '&:hover': {
                '& .cstProfileImageEdit': {
                    display: 'flex',
                    cursor: 'pointer',
                },
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
            '&.cstEmptyProfile': {
                height: '300px',
                minHeight: '360px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                background: isDark(theme) ? colors.emptyImgageBg : colors.lightGray,
                borderRadius: theme.spacing(1),
                '& .emptyBox': {
                    width: theme.spacing(3.75),
                    '& img': {
                        borderRadius: 0,
                    },
                },
            },
        },
    },
    '& .contactUs': {
        '& .infoBox': {
            padding: theme.spacing(5),
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-start',
            alignItems: 'center',
            backgroundColor: isDark(theme) ? colors.blackColor : colors.whiteSmoke,
            borderRadius: theme.spacing(1.25),
            '& .MuiTypography-root': {
                display: 'flex',
                alignItems: 'center',
                gap: theme.spacing(1),
                fontFamily: 'good_sansregular',
                '& .MuiLink-root': {
                    color: isDark(theme) ? colors.white : colors.blackColor,
                    marginBottom: 0,
                    '&.cstLink': {
                        color: '#2FABE1',
                    },
                },
            },
        },
        [theme.breakpoints.down(1200)]: {
            flexDirection: 'column-reverse',
            '& .infoBox': {
                marginTop: theme.spacing(1.5),
                padding: theme.spacing(2),
                '& .MuiTypography-root': {
                    marginBottom: theme.spacing(1.5),
                },
            },
            '& img': {
                width: '35%',
            },
        },
        '& .cstHeaterName': {
            '& .MuiOutlinedInput-root': {
                '& fieldset': {
                    borderColor: fieldSetColor(theme), // default border
                    borderBottomWidth: 2,
                },
                '&:hover fieldset': {
                    borderColor: fieldSetColor(theme), // optional: hover color
                    borderBottomWidth: 2,
                },
                '&.Mui-focused fieldset': {
                    borderColor: fieldSetColor(theme),
                    borderBottomWidth: 2,
                },
            },

            '& .MuiInputBase-input': {
                color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                '-webkit-text-fill-color': 'inherit',
            },
        },
    },
    '& .cstSlider': {
        '& .MuiSlider-root': {
            height: theme.spacing(1),
            background: fieldSetColor(theme),
            padding: 0,
            margin: theme.spacing(2, 0),
            '& .MuiSlider-rail': {
                height: theme.spacing(0.5),
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 10%, #B3E3F3 20%, #FDCC3F 40%, #FF8524 60%, #E03C23 80%, #441212 100%)',
                opacity: 1,
                marginHorizontal: '5px',
            },
            '& .MuiSlider-track': {
                background: 'transparent',
                border: 'none',
            },
            '& .MuiSlider-mark': {
                background: 'transparent',
            },
            '& .MuiSlider-markLabel': {
                color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                top: theme.spacing(2.25),
                fontSize: theme.spacing(1),
                fontFamily: 'good_sansbold',
            },
            '& .MuiSlider-markLabel[data-index="0"]': {
                left: '2% !important',
            },
            '& .MuiSlider-markLabel[data-index="1"]': {
                left: '98% !important',
            },
            '& .MuiSlider-thumb': {
                background: 'linear-gradient(320.66deg, rgb(20, 21, 21) 14.75%, rgb(46, 50, 54) 84.81%)',
                boxShadow: 'none',
                '&:before': {
                    width: '40%',
                    height: '40%',
                    background: colors.SliderThumb,
                },
                '& .MuiSlider-valueLabelOpen': {
                    background: 'transparent',
                    padding: 0,
                    top: 0,
                    fontFamily: 'good_sansbold',
                    color: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
                },
            },
        },
    },
    '& .cstTextFeild': {
        position: 'relative',
        '& .MuiInputBase-root': {
            '& .MuiInputBase-input': {
                padding: theme.spacing(2.0625, 0),
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderWidth: '0px 0px 1px 0px',
                borderRadius: 0,
            },
            '&.Mui-focused': {
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: 'none',
                },
            },
        },
        '& .cstEdit': {
            position: 'absolute',
            top: theme.spacing(5.875),
            right: 0,
        },
    },
    '& .cstModifyBtn': {
        fontSize: theme.spacing(1.25),
        background: theme.palette.mode === 'dark' ? colors.white : colors.blackColor,
        color: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
        padding: theme.spacing(0.375),
    },
    '& .cstActionBtns': {
        '& .cstBtnWrapper': {
            '& .MuiButtonBase-root': {
                padding: 0,
                zIndex: 1,
                '& .MuiStack-root': {
                    padding: theme.spacing(1.75, 2),
                    borderRadius: theme.spacing(2),
                    background: theme.palette.mode === 'dark' ? colors.blackColor : colors.white,
                    width: '100%',
                },
            },
            position: 'relative',
            padding: theme.spacing(0.125),
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            overflow: 'hidden',
            borderRadius: theme.spacing(2),
            '&.cstActiveBtn': {
                height: '100%',
                '&::after': {
                    ...focuseEffect(),
                    zIndex: 0,
                    borderRadius: theme.spacing(2),
                },
                '& .active': {
                    color: colors.verifyText,
                },
            },
        },
    },
    '& .cstImgContainer': {
        position: 'relative',
        '&::after': {
            position: 'absolute',
            height: '100%',
            width: '100%',
            rotate: '180deg',
        },
    },
}));

const getIconFill = (theme: any) => (theme.palette.mode === 'dark' ? colors.white : colors.blackColor);

const getButtonShadow = (theme: any) =>
    theme.palette.mode === 'dark'
        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040';

const logoStyles = (theme: any) => ({
    '& svg': { fill: getIconFill(theme) },
    '&.otpLogo svg': {
        width: theme.spacing(7.5),
        fill: colors.blackColor,
    },
    '&.passwordLogo svg': {
        width: theme.spacing(18.5),
        fill: 'none',
        '& path': { stroke: getIconFill(theme) },
    },
    '&.forgotIcon svg path': {
        stroke: getIconFill(theme),
        fill: 'none',
    },
});

const buttonStyles = (theme: any) => ({
    background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
    padding: theme.spacing(2, 0),
    boxShadow: getButtonShadow(theme),
    letterSpacing: '1.25px',
});

const activeButtonStyles = (theme: any) => ({
    background:
        'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
    borderRadius: theme.spacing(4),
    '&::after': {
        content: "''",
        background:
            'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
        position: 'absolute',
        width: '100%',
        height: '100%',
        zIndex: -1,
        inset: 0,
        borderRadius: theme.spacing(4),
    },
});

// --- Styled Component ---
export const ProfileWrapper = styled(Grid2)(({ theme }) => ({
    height: '100dvh',

    '& .imgContainer': {
        overflow: 'hidden',
        height: '100dvh',
        '& .MuiBox-root': {
            width: '100%',
            height: '100%',
            background: `url(${SplashLogo}) no-repeat`,
            backgroundSize: 'cover',
        },
    },

    '& .feildsLabels': {
        overflow: 'auto',
        height: '100vh',

        '& .logo': logoStyles(theme),

        '& .MuiFormControl-root': {
            '& .MuiInputBase-root': {
                height: 'auto',
                padding: theme.spacing(0.5, 0),
                borderRadius: 0,
                fontFamily: 'good_sansregular',
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
                borderBottom: `1px solid ${getIconFill(theme)}`,
            },
        },

        '& .MuiFormControlLabel-label': { fontSize: '12px' },

        '& .cstBtnWrapper .MuiBox-root': {
            position: 'relative',
            padding: theme.spacing(0.375),

            '& .cstBtn': buttonStyles(theme),
            '& .cstBtn2': {
                ...buttonStyles(theme),
                border: '1px solid var(--Color-tokens-Strokes-Neutral-Dark, #47474B)',
            },
            '&:active': activeButtonStyles(theme),
        },

        '& .divider .MuiTypography-h5': {
            position: 'relative',
            '&:before': dividerMixin(270, '19%', 'auto'),
            '&:after': dividerMixin(90, 'auto', '21%'),
        },

        '& .mediaSlot .MuiIconButton-root': {
            width: theme.spacing(6.25),
            height: theme.spacing(6.25),
            background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
            '& svg': { fill: getIconFill(theme) },
        },

        '& .cstCheckbox svg path': { fill: getIconFill(theme) },

        '& .cstResendBtn': {
            color: getIconFill(theme),
            '&.Mui-disabled': {
                color: theme.palette.mode === 'dark' ? colors.lightHead : colors.lightTrack,
                cursor: 'not-allowed',
                opacity: 0.6,
            },
        },

        '& .backBtn': {
            position: 'absolute',
            top: theme.spacing(2.5),
            background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
            '& svg': { color: colors.info },
        },

        '& .cstList .MuiList-root': {
            listStyleType: 'disc',
            padding: theme.spacing(1, 4),
            '& .MuiListItem-root': {
                display: 'list-item',
                padding: theme.spacing(0, 1),
            },
        },

        '& .cstInput': {
            '& .MuiTextField-root': { marginBottom: 0 },
            '& .MuiInputBase-input': { padding: theme.spacing(1, 0) },
        },

        '& .forgot-btn': {
            fontSize: theme.spacing(1.5),
            fontFamily: 'good_sansregular',
            textTransform: 'capitalize',
            letterSpacing: 0,
            color: getIconFill(theme),
        },
    },

    '& .timer': {
        minWidth: theme.spacing(4.375),
        fontFamily: 'good_sansmedium !important',
    },
}));

export const AccountDeleteWrapper = styled(Grid2)(({ theme }) => ({
    marginTop: '10px',
    '& .cstBtnWrapper': {
        '& .MuiBox-root': {
            position: 'relative',
            padding: theme.spacing(0.2),
            margin: '10px 10px',
            width: '225px',
            '& .cstBtn': {
                width: '220px',

                background: theme.palette.mode === 'dark' ? colors.darkBgButton : colors.lightBgButton,
                padding: theme.spacing(2, 0),
                boxShadow:
                    theme.palette.mode === 'dark'
                        ? '0px 0px 2px 0px #00000005 inset, -6px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040'
                        : '0px 0px 2px 0px #00000005 inset, 0px -6px 16px 0px #FFFFFF0A, 6px 6px 16px 0px #00000040',
                letterSpacing: '1.25px',
            },

            '&:active': {
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                borderRadius: theme.spacing(4),
            },

            '&:active::after': {
                content: "''",
                background:
                    'linear-gradient(90deg, #2FABE1 0%, #59BDE7 5.13%, #89D1ED 11.85%, #A8DEF1 16.98%, #B3E3F3 19.87%, #FDCC3F 40.5%, #FF8524 61.36%, #E03C23 80.8%, #441212 100%)',
                position: 'absolute',
                width: '100%',
                height: '100%',
                zIndex: -1,
                inset: 0,
                borderRadius: theme.spacing(4),
            },
        },
    },
}));
